import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { PageOne, PageTwo, PageThree } from './components';
;
export const DocumentSixteen = memo(({ pharmacy, traderInfo, }) => (_jsxs(_Fragment, { children: [_jsx(PageOne, { pharmacy: pharmacy }), _jsx(PageTwo, { pharmacy: pharmacy, traderInfo: traderInfo }), _jsx(PageThree, { pharmacy: pharmacy, traderInfo: traderInfo })] })));
